import { useIntl } from 'react-intl';

import MapIcon from '@/assets/icons/bullseye-line.svg';
import EmptyMappingIcon from '@/assets/icons/empty-mapping.svg';
import { EmptyState } from '@/components/ui/empty-state';

import { EditStageMappings } from './edit-stage-mappings';

export function NoMapping({
  hiringGoalConversionRate,
  refetchFunnelData,
}: {
  hiringGoalConversionRate: number | null;
  refetchFunnelData: () => Promise<void>;
}) {
  const intl = useIntl();

  return (
    <div className="border-fx-neutral-200 flex h-full max-h-full flex-1 gap-8 overflow-hidden rounded-lg border bg-white pb-8">
      <EditStageMappings
        funnelData={[]}
        hiringGoalConversionRate={hiringGoalConversionRate}
        refetchFunnelData={refetchFunnelData}
      >
        <EmptyState
          icon={EmptyMappingIcon}
          header={intl.formatMessage({
            defaultMessage: 'Map now to enable tracking',
          })}
          description={intl.formatMessage({
            defaultMessage: 'Hire stages aren’t mapped to source stages yet.',
          })}
          buttonIcon={MapIcon}
          buttonTitle={intl.formatMessage({
            defaultMessage: 'Map',
          })}
        />
      </EditStageMappings>
    </div>
  );
}
